"use client";

import { createContext } from "react";
import { PASSING_DATE_FORMAT } from "utils/constant";

// ----------------------------------------------------------------------

export const AuthContext = createContext({
    user: null,

    isSuperAdmin: false,
    isHasWebsite: false,
    moduleMarketPlace: false,
    moduleInventoryTire: false,
    moduleMembershipPlan: false,

    // Business information
    companyInfoSet: false,
    businessRegistered: false,
    businessRegisterType: 'regular',

    // Formatting and preferences
    DATE_FORMAT: PASSING_DATE_FORMAT,
    connectWithZoho: false,


    // Country-specific settings
    DECIMAL_VALUE: 2,
    CURRENCY_SYMBOL: "₹",
    CURRENCY_NAME: "INR",
    SHOW_HSN_CODE: false,
    isGcc: false,
});
